// extracted by mini-css-extract-plugin
export default {"wrapper":"Author_wrapper__HsJm8","name":"Author_name__rMW0j"};